import { getCurrentPath } from "@faire/web/common/Path";
import { matchPath } from "react-router-dom";

import { useCheckoutNudgeStore } from "./CheckoutNudgeStore";

const WHITELIST_PAGES = ["/"];

export const useCheckoutNudge = () => {
  const [{ isOpen, shouldConsiderNudgeInTheSession }, setCheckoutNudgeStore] =
    useCheckoutNudgeStore(["isOpen", "shouldConsiderNudgeInTheSession"]);

  const updateHasNudgedInCurrentPage = (hasNudgedInCurrentPage: boolean) => {
    setCheckoutNudgeStore({
      checkoutNudgedInCurrentPage: hasNudgedInCurrentPage,
    });
  };

  const updateWhenVisible = () => {
    setCheckoutNudgeStore({
      checkoutNudgedInCurrentPage: true,
      isOpen: true,
      shouldConsiderNudgeInTheSession: false,
    });
  };

  const onCloseClick = () => {
    setCheckoutNudgeStore({
      isOpen: false,
    });
  };

  const shouldShowNudge = (pathName?: string) => {
    const currentPathName = pathName ?? getCurrentPath().pathname;

    const isWhitelistPage = !!WHITELIST_PAGES.find((whitelistPage) =>
      matchPath(currentPathName, {
        path: whitelistPage,
        exact: true,
      })
    );

    return (shouldConsiderNudgeInTheSession || isOpen) && isWhitelistPage;
  };

  return {
    updateHasNudgedInCurrentPage,
    updateWhenVisible,
    onCloseClick,
    shouldShowNudge,
  };
};
